module.exports = __webpack_public_path__ + "img/undraw_no_data_qbuo.8b7feb68.svg";